import { createFileRoute, Outlet, redirect, useRouterState } from "@tanstack/react-router";
import { SidebarProvider, SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { SalonSidebar } from "@/components/salon-sidebar";
import { Separator } from "@/components/ui/separator";

function getTokenFromCookie() {
  const match = document.cookie.match(/access_token=([^;]+)/);
  return match?.[1] ?? null;
}

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: () => {
    const token = getTokenFromCookie();
    if (!token) {
      throw redirect({ to: "/login" });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const router = useRouterState();
  const isAdminRoute = router.location.pathname.startsWith("/admin");

  // Admin routes have their own layout with AdminSidebar
  if (isAdminRoute) {
    return <Outlet />;
  }

  return (
    <SidebarProvider>
      <SalonSidebar />
      <SidebarInset>
        <header className="flex h-12 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
        </header>
        <div className="flex-1 overflow-auto p-6">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
